import PropTypes from 'prop-types'
import React from 'react'

const Link = ({ children, className, href, openInNew, value }) => {
  if (href === null) {
    return null
  }

  const optional = {
    rel: 'noopener noreferrer',
    target: '_blank'
  }
  const attr = openInNew ? optional : {}

  return (
    <a className={className} href={href} {...attr}>
      {children === null ? value : children}
    </a>
  )
}

Link.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  href: PropTypes.string,
  openInNew: PropTypes.bool,
  value: PropTypes.string
}

Link.defaultProps = {
  className: null,
  children: null,
  href: null,
  openInNew: false,
  value: null
}

export default Link
